module.exports = __webpack_public_path__ + "static/media/photo3@2x.0686530a.jpg";